import { render, staticRenderFns } from "./frameOps.vue?vue&type=template&id=4f3a8360"
import script from "./frameOps.vue?vue&type=script&lang=js"
export * from "./frameOps.vue?vue&type=script&lang=js"
import style0 from "./frameOps.vue?vue&type=style&index=0&id=4f3a8360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports